/**
 * VADM-5217 / VADM-5101: valor mínimo de Pós-Graduação para sellers novos.
 *
 * A regra (data de corte de email_verified_at + exceção manual) vive no backend.
 * O get-user devolve `pos_graduation_min_price` já resolvido:
 *   - número > 0 -> mínimo efetivo (R$ 2.000 padrão ou o valor da exceção)
 *   - null       -> regra não se aplica (seller antigo ou e-mail não verificado)
 * O front só consome esse campo, sem recalcular data nem exceção.
 */
export const POS_GRADUATION_FORMAT = "POS_GRADUATION";

/**
 * Retorna o mínimo efetivo (number) ou null quando a regra não se aplica.
 * Só vale para produtos do formato POS_GRADUATION.
 */
export function getPosGraduationMinPrice(profile, format) {
  if (format !== POS_GRADUATION_FORMAT) {
    return null;
  }
  const raw = profile ? profile.pos_graduation_min_price : null;
  if (raw === null || raw === undefined || raw === "") {
    return null;
  }
  const value = Number(raw);
  return Number.isFinite(value) && value > 0 ? value : null;
}

/** Formata o valor em pt-BR sem símbolo, ex: 2000 -> "2.000,00". */
export function formatMinPrice(value) {
  return Number(value).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
